import { useMemo, useState, useEffect, useContext } from 'react'
import moment from 'moment-timezone'

import { IconButton, Button, Box, Tooltip } from '@mui/material'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'

import {
  MRT_ToggleDensePaddingButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table'

import { AppContext } from '/providers/app-context'
import { getTemplateData } from '/providers/templates-api'
import StudioTable, { useStudioTable } from '/components/studio-table'

import SaveAltIcon from '@mui/icons-material/SaveAlt'
import DataExportDialog from "../data-export-dialog"
import excelExport from './notifications-list-to-excel'
import NotifySelectedDialog from './notify-selected-dialog'

const NotificationsTable = ({ templateId, pass, data, loading, refreshNotifications }) => {

  const { client, apiSource, apiKey } = useContext(AppContext)

  const [dataExportDialogOpen, setDataExportDialogOpen] = useState(false)
  const [openNotify, setOpenNotify] = useState(false)
  const [template, setTemplate] = useState()
  const [limitedUpdates, setLimitedUpdates] = useState(false)

  useEffect(() => {
    getTemplate()

      if (client.limitUpdates) { // Client is only permitted  a limite dnumnber of updates per 24 hours
        if (pass.update_counter >= client.updates_per_day) {
          setLimitedUpdates(true)
        }
      }

  }, [templateId])

  const getTemplate = async () => {
    const t = await getTemplateData({ apiSource, apiKey, templateId })
    if (!t.error) setTemplate(t.template)
    // TODO handler error
  }

  const columns = useMemo(() => [
    {
      id: 'notification_date',
      accessorFn: (originalRow) => moment.utc(originalRow.notification_date).tz('Europe/London'),
      header: 'Created',
      filterVariant: 'date-range',
      sortingFn: 'datetime',
      size: 200,
      Cell: ({ cell }) => cell.getValue().format("DD MMM YYYY HH:mm")
    },
    {
      accessorKey: 'message',
      header: 'Message',
      filterVariant: 'autocomplete',
      size: 800,
    },
  ])

  const table = useStudioTable({
    tableKey: 'pass-notifications',
    columns,
    data,
    state: {
      isLoading: false,
      showProgressBars: loading,
    },
    localization: {
      noRecordsToDisplay: loading ? 'Loading…' : 'No records to display',
      noResultsFound: loading ? 'Loading…' : 'No results found',
    },
    initialState: { showColumnFilters: false },
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableRowActions: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    positionToolbarAlertBanner: "none",
    getRowId: (originalRow) => originalRow.pass_id,
    renderToolbarInternalActions: ({ table }) => (
      <Box>
        <MRT_ToggleGlobalFilterButton table={table} />
        <MRT_ToggleFiltersButton table={table} />
        <MRT_ShowHideColumnsButton table={table} />
        <MRT_ToggleDensePaddingButton table={table} />
        <MRT_ToggleFullScreenButton table={table} />
        <Tooltip title="Export"><IconButton onClick={() => setDataExportDialogOpen(true)}><SaveAltIcon /></IconButton></Tooltip>
      </Box>
    ),
    renderTopToolbarCustomActions: () => (
      <div className='flex flex-row gap-5'>
        <Button onClick={() => setOpenNotify(true)} className='link' disabled={limitedUpdates}><EmailOutlinedIcon className='mr-2' /> Send Notification</Button>
      </div>
    )
  })

  return (
    <>
      <StudioTable table={table} />
      <DataExportDialog open={dataExportDialogOpen} setOpen={setDataExportDialogOpen} fileName={`${templateId}-(${pass.pass_id})-notifications`} data={data} excelExport={excelExport} table={table} />
      <NotifySelectedDialog open={openNotify} setOpen={setOpenNotify} template={template} passes={[pass]} refresh={refreshNotifications} />
    </>)
}

export default NotificationsTable
